__turbopack_context__.v({
  "buttonStack": "AppDownloadDialog-module__FHG1AG__buttonStack",
  "dialogContent": "AppDownloadDialog-module__FHG1AG__dialogContent",
  "frameLogoContainer": "AppDownloadDialog-module__FHG1AG__frameLogoContainer",
});
